var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh2 = function SvgRefresh2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.334 7A5.836 5.836 0 0 1 7.5 12.833c-3.22 0-5.186-3.243-5.186-3.243m0 0h2.637m-2.637 0v2.917M1.667 7A5.82 5.82 0 0 1 7.5 1.167c3.891 0 5.834 3.243 5.834 3.243m0 0V1.493m0 2.917h-2.59"
  })));
};
export default SvgRefresh2;